import React, { Component } from 'react';
import {connect} from 'react-redux';

import Api from '../../util/api/Api';
import {selectNavMenu} from '../../actions';

class NavMenuItem extends Component {
  
  async getChList () {
    try{
        const result = await Api.GetChList({chNo: ''}); 
    } catch(e) {
      console.log(e);
    }
  }
  
  async setMenuLog () {
    try{
      const result = await Api.WriteConnectLog({
        TYPE: "SETUP",
        MSG: "설정 메뉴로 이동했습니다."
      }); 
    } catch(e) {
      console.log(e);
    }
    
  }

  render() {
    const {info, selected, selectedMenu} = this.props;
    const selectNavMenu = async () => {
      if(selectedMenu !== info.id){
        if(info.id === "SETTING") await this.setMenuLog(); // 설정 메뉴로 이동시 로그 저장
        else await this.getChList(); // 메뉴 변경시 sessiont timeout 연장
        await this.props.selectNavMenu(info.id);
      }
    }
    
    return (
        <div className={selected ? 'item is-selected' : 'item'} onClick={selectNavMenu}>{info.title} </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedMenu: state.selectedMenu,
  }
};

const mapDispatcherToProps = dispatch => {
  return {
    selectNavMenu: (selectedMenu) => dispatch(selectNavMenu(selectedMenu))
  }
};

NavMenuItem = connect(mapStateToProps, mapDispatcherToProps)(NavMenuItem);




export default NavMenuItem;


// WEBPACK FOOTER //
// ./src/components/menu/NavMenuItem.js